<template>
  <div class="fill-height back ma-6 justify-center align-content-center text-center">
    <v-layout align-center justify-center>
      <v-card width="500px" elevation="1" class="">
        <v-card-text>
          <img alt="pending" width="200px" src="../assets/pending.jpg"/>
          <div>{{tiketdepositresponse.invoice}}</div>
          <div>Silahkan lakukan pembayaran</div>
          <div>Nominal Transfer</div>
          <div class="ma-4"><h2>Rp {{formatAngka(tiketdepositresponse.nominal)}}</h2></div>
          <div>Mohon transfer sesuai jumlah yang tertera
            (untuk penyesuaian admin)</div>
          <div>Informasi Rekening Tujuan</div>
        </v-card-text>
        <v-card-actions>
          <v-btn class="primary" @click="selanjutnya" block elevation="0">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-layout>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Utils from '@/plugins/utils'

export default {
  name: 'KonfirmasiDeposit',
  data: () => ({
    inv: ''
  }),
  mounted () {
    this.inv = this.$route.params.id
  },
  computed: {
    ...mapState('SaldoStore', ['tiketdepositresponse'])
  },
  methods: {
    ...mapActions('SaldoStore', ['cleardata']),
    selanjutnya () {
      this.cleardata()
      this.$router.push('/trxpembelian')
    },
    formatAngka (val) {
      return Utils.formatAngka(val)
    }
  }
}
</script>

<style scoped>

</style>
